// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import { InputNumber, InputNumberProps } from 'antd';
import React, { ReactElement } from 'react';

import './THInputNumber.scss';

interface THInputNumberProps extends InputNumberProps {
    borderless?: boolean;
    errorless?: boolean;
    noArrows?: boolean;
}

export const THInputNumber = ({
    borderless = false,
    errorless = false,
    noArrows = false,
    className,
    autoComplete,
    ...props
}: THInputNumberProps): ReactElement => (
    <InputNumber
        className={classList('th-input-number', className, {
            'no-border': borderless,
            'no-error': errorless,
            'no-arrows': noArrows,
        })}
        size="large"
        autoComplete={autoComplete || 'off'}
        {...props}
    />
);
